<template>
  <div class="chart-box">
    <el-row :gutter="20" style="margin: 30px 0;">
      <el-col :span="6">
        <centerLeft defultIndex="3-3" />
      </el-col>
      <el-col :span="18">
        <el-card class="box-card" shadow="never">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="type-opr"
            style="margin:0 0  10px 0;"
          >
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>修改密码</el-breadcrumb-item>
          </el-breadcrumb>
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>个人中心</span>
            </div>
            <el-form :rules="rules" ref="dataForm" :model="dataForm" label-width="100px">
              <el-form-item label="旧密码" prop="oldPwd">
                <el-input type="password" v-model="dataForm.oldPwd"></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPwd">
                <el-input type="password" v-model="dataForm.newPwd"></el-input>
              </el-form-item>
              <el-form-item label="确认新密码" prop="newPwd2">
                <el-input type="password" v-model="dataForm.newPwd2"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitPass">保存</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import centerLeft from '../../components/center-left.vue'
export default {
  name: 'password',
  components: {
    centerLeft,
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.dataForm.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      activeName: 'second',
      isRouter: true,
      dataForm: {
        loginName: '',
        oldPwd: '',
        newPwd: '',
        newPwd2: '',
      },
      rules: {
        oldPwd: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        newPwd2: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    submitPass() {
      let currThis = this
      let loginName = this.$cookies.get('loginName')
      let oldPwd = this.dataForm.oldPwd
      let newPwd = this.dataForm.newPwd
      axios({
        method: 'post',
        url:
          '/api/web/updatePwd?loginName=' +
          loginName +
          '&oldPwd=' +
          oldPwd +
          '&newPwd=' +
          newPwd,
      })
        .then(function (response) {
          alert(response.data.msg)
          if (response.data.code === '8001') {
            currThis.dataForm = {
              loginName: '',
              oldPwd: '',
              newPwd: '',
              newPwd2: '',
            }
          }
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/center/password.vue